import React from 'react'
import Breadcrub from '../Common/Breadcrub'
import { Link } from 'react-router-dom'

const Administrative = () => {
  return (
    <>
        <Breadcrub title="Administrative Committee" />
        <section>
            <div class="container">
                <div class="row mb-1-9 mb-xl-2-9">
                    <div class="col-lg-3 mb-1-9 mb-md-2-5 mb-lg-0">
                        <ul>
                            <li>
                                <Link className='font-24' to={'/img/pdf/anti-discrimination-cell.pdf'} target='blank'>Anti Discrimination Cell</Link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 mb-1-9 mb-md-2-5 mb-lg-0">
                        <ul>
                            <li>
                                <Link  className='font-24' to={'/img/pdf/anti-ragging-committee.pdf'} target='blank'>Anti Ragging Committee</Link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 mb-1-9 mb-md-2-5 mb-lg-0">
                        <ul>
                            <li>
                                <Link className='font-24' to={'/img/pdf/gender-sensitization-cell.pdf'} target='blank'>Gender Sensitization Cell</Link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 mb-1-9 mb-md-2-5 mb-lg-0">
                        <ul>
                            <li>
                                <Link className='font-24' to={'/img/pdf/tpcell.pdf'} target='blank'>Training & Placement Cell</Link>
                            </li>
                        </ul>
                    </div>                   
                </div>
            </div>
        </section>
    </>
  )
}

export default Administrative
